import { fetchPostTipList } from '@/api/post/post';
import { tipTypeOptions } from '@/const/crud/tip/record';
export default {
  data() {
    return {
      id: 0, // post id
      postTipLoaded: false,
      tipTypeOptions,
      postTipData: [],
      postTipPage: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100],
        layout: 'total, sizes, prev, pager, next, jumper'
      },
    }
  },
  mounted() {
    this.postTipLoaded = false;
  },
  methods: {
    initPostTip() {
      if (this.postTipLoaded) {
        return;
      }

      this.getPostTipList();
    },
    getPostTipList() {
      let params = {
        current: this.postTipPage.currentPage,
        size: this.postTipPage.pageSize,
        postId: this.id
      }
      fetchPostTipList(params).then(response => {
        if (response.data.data != null) {
          response.data.data.records.forEach(function(record) {
            if (!record.tipType) {
              record.tipType = { label: '其他', value: -1 }
            } else {
              record.tipType = tipTypeOptions.find(item => item.value == record.tipType).label
            }
          })
          this.postTipData = response.data.data.records;
          this.postTipPage.total = response.data.data.total;
        } else  {
          this.postTipData = []
          this.postTipPage.total = 0;
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: '获取打赏列表失败',
          type: 'error'
        });
      });
      this.postTipLoaded = true;
    },
    postTipCurrentChange(val) {
      this.postTipPage.currentPage = val;
      this.getPostTipList();
    },
    postTipSizeChange(val) {
      this.postTipPage.pageSize = val;
      this.getPostTipList();
    },
  }
}
